import request from '@/api/config'
import axios from 'axios';
import { useUserStore } from '@/store/user';

const baseUrl = process.env.NODE_ENV === 'development' ? '/tc-server' : 'https://peiqisport.club';
// const baseUrl = process.env.NODE_ENV === 'development' ? '/tc-server' : 'http://110.41.76.11:3001';
// const baseUrl = process.env.NODE_ENV === 'development' ? '/tc-server' : 'http://118.196.116.202:3001';

export function getAllTask () {
  return request({
    url: `${baseUrl}/data-use/all-tasks`,
    method: 'get'
  })
}

/**
 * 创建任务的接口
 * @param name 任务名称
 * @param apiUrl 接口地址
 * @param cronExpression 定时表达式
 * @param description 任务描述
 */
export function createTask (name: string, apiUrl: string, cronExpression: string, description: string) {
  return request({
    url: `${baseUrl}/data-use/create-task`,
    method: 'post',
    data: {
      name,
      apiUrl,
      cronExpression,
      description
    }
  })
}

/**
 * 编辑任务的接口
 * @param id 任务的 ID
 * @param name 任务名称
 * @param apiUrl 接口地址
 * @param cronExpression 定时表达式
 * @param description 任务描述
 */
export function editTaskById (id: number, name: string, apiUrl: string, cronExpression: string, description: string) {
  return request({
    url: `${baseUrl}/data-use/edit-task/${id}`,
    method: 'post',
    data: {
      name,
      apiUrl,
      cronExpression,
      description
    }
  })
}

/**
 * 启动任务的接口
 */
export function startTask (id: number) {
  return request({
    url: `${baseUrl}/data-use/start-task/${id}`,
    method: 'post'
  })
}

/**
 * 停止任务的接口
 * @param id 任务的 ID
 */
export function stopTask (id: number) {
  return request({
    url: `${baseUrl}/data-use/stop-task/${id}`,
    method: 'post'
  })
}

/**
 * 删除任务的接口
 * @param id 任务的 ID
 */
export function deleteTaskById (id: number) {
  return request({
    url: `${baseUrl}/data-use/delete-task/${id}`,
    method: 'post'
  })
}

/**
 * 查找匹配数据的接口
 */
export function findMatchData (params: {
  dateStart?: string;
  dateEnd?: string;
  date?: string;
  homeName?: string;
  awayName?: string;
  leagueName?: string;
  isSingle?: boolean;
  page: number;
  pageSize: number;
}) {
  return request({
    url: `${baseUrl}/data-use/match/find`,
    method: 'post',
    data: params
  })
}

/**
 * 删除匹配数据的接口
 * @param id 匹配数据的 ID
 */
export function deleteMatchData (id: number) {
  return request({
    url: `${baseUrl}/data-use/match/delete/${id}`,
    method: 'post'
  })
}

/**
 * 更新匹配数据的接口
 * @param id 匹配数据的 ID
 * @param data 更新的数据
 */
export function updateMatchData (id: number, data: any) {
  return request({
    url: `${baseUrl}/data-use/match/update/${id}`,
    method: 'post',
    data
  })
}

/**
 * 保存匹配数据的接口
 * @param data 要保存的数据
 */
export function saveMatchData (data: any) {
  return request({
    url: '${baseUrl}/data-use/match/save',
    method: 'post',
    data
  })
}

/**
 * 根据比赛 ID 查找匹配投注数据的接口
 * @param matchId 比赛的 ID
 */
export function findMatchBettingData (matchId: string, source?: string) {
  return request({
    url: `${baseUrl}/data-use/match-betting-data/find/${matchId}`,
    params: source ? { view: 'pc-collector', source } : undefined,
    method: 'get'
  })
}
/**
 * 新增用户接口
 * @param data 用户数据
 */
export function addUser (data: any) {
  return request({
    url: `${baseUrl}/data-use/user/create`,
    method: 'post',
    data
  })
}

/** 移动端管理员创建普通用户账号 */
export function addMobileUser (data: any) {
  return request({
    url: `${baseUrl}/data-use/user/create-mobile`,
    method: 'post',
    data
  })
}

/**
 * 查询用户列表
 * @param data 查询参数
 *  @param data.username 用户名
 *  @param data.page 页码
 *  @param data.pageSize 每页大小
 *  @return 用户列表
 * */
export function getUserList (data: any) {
  return request({
    url: `${baseUrl}/data-use/user/list`,
    method: 'post',
    data
  })
}
// 登陆接口
export function login (data: any) {
  return request({
    url: `${baseUrl}/data-use/user/login`,
    method: 'post',
    data
  })
}
export function logout (data: any) {
  return request({
    url: `${baseUrl}/data-use/user/logout`,
    method: 'post',
    data
  })
}
// /data-use/lottery/lotto-history
export function getLottoHistory (terms: number) {
  return axios({
    url: `https://webapi.sporttery.cn/gateway/lottery/getHistoryPageListV1.qry?gameNo=85&provinceId=0&pageSize=50&isVerify=1&pageNo=1&termLimits=${terms}`,
    method: 'get',
  })
}
// const trendConfig = {
//   '5006006398': {
//     lott: {
//       hasAd: true,
//       trendAreaHeight: 640,
//       terms: 30,
//       dictName: 'lott-activity'
//     },
//     rank: {
//       hasAd: false,
//       trendAreaHeight: 1920,
//       terms: 50,
//     },
//     sevenStart: {
//       hasAd: false,
//       trendAreaHeight: 1920,
//       terms: 50,
//     }
//   },
//   '5006006385': {
//     lott: {
//       hasAd: true,
//       trendAreaHeight: 640,
//       terms: 30,
//       dictName: 'lott-activity'
//     },
//     rank: {
//       hasAd: false,
//       trendAreaHeight: 1920,
//       terms: 50,
//     },
//     sevenStart: {
//       hasAd: false,
//       trendAreaHeight: 1920,
//       terms: 50,
//     }
//   }
// }

export function getGyj () {
  return axios({
    url: `https://webapi.sporttery.cn/gateway/pwf/getWelfareFundDetailV1.qry?gameIdList=0`,
    method: 'get',
  })
}
export function getMatchCalculator (options: { timeout?: number; signal?: AbortSignal } = {}) {
  return axios({
    url: `https://webapi.sporttery.cn/gateway/uniform/football/getMatchCalculatorV1.qry?channel=c`,
    method: 'get',
    ...options,
  }) as Promise<{
    success: boolean
    value: any
  }>
}


/**
 * 查询存储的赔率快照（比赛开打后 live API 不返回时降级使用）
 */
export function getStoredMatchOdds(matchNumStr: string) {
  return request({
    url: `${baseUrl}/data-use/match-odds-stored/by-match`,
    method: "post",
    data: { matchNumStr },
  })
}

// /data-use/lottery/rank-game-history
export function getRankGameHistory () {
  return request({
    url: `${baseUrl}/data-use/lottery/rank-game-history`,
    method: 'get',
  })

}
export function getRankGameHistory3 () {
  return request({
    url: `${baseUrl}/data-use/lottery/rank-game-history-3`,
    method: 'get',
  })
}
export function getSevenStartGameHistory () {
  return request({
    url: `${baseUrl}/data-use/lottery/seven-start-game-history`,
    method: 'get',
  })
}


/**
 * 查询历史比赛数据列表
 * @param data 查询参数
 * @param data.date 比赛日期
 * @param data.leagueName 联赛名称
 * @param data.teamName 球队名称
 * @param data.page 页码
 * @param data.pageSize 每页大小
 * @returns 历史比赛数据列表
 */
export function getHistoryMatchList (data: any) {
  return request({
    url: `${baseUrl}/data-use/jc-match/list`,
    method: 'post',
    data
  })
}
export function queryJcMatchId (data: any) {
  return request({
    url: `${baseUrl}/data-use/jc-match/get-matchId-by-time-and-num`,
    method: 'post',
    data
  })
}

export function getJcMatchOddsByMatchId (data: any) {
  return request({
    url: `${baseUrl}/data-use/jc-match/get-odds-data-by-matchId`,
    method: 'post',
    data
  })
}

export function getJcMatchHadOddsTrend (data: any) {
  return request({
    url: `${baseUrl}/data-use/jc-match/had-odds-trend`,
    method: 'post',
    data
  })
}
export function getJcMatchHHadOddsTrend (data: any) {
  return request({
    url: `${baseUrl}/data-use/jc-match/hhad-odds-trend`,
    method: 'post',
    data
  })
}
// 新增role的增删改查接口 /role/create、/role/getAll、/role/getById、/role/update、/role/delete
export function getRoleList (data: any) {
  return request({
    url: `${baseUrl}/data-use/role/getAll`,
    method: 'post',
    data
  })
}
export function getRoleById (data: any) {
  return request({
    url: `${baseUrl}/data-use/role/getById`,
    method: 'post',
    data
  })
}
export function createRole (data: any) {
  return request({
    url: `${baseUrl}/data-use/role/create`,
    method: 'post',
    data
  })
}
export function updateRole (data: any) {
  return request({
    url: `${baseUrl}/data-use/role/update`,
    method: 'post',
    data
  })
}
export function deleteRole (data: any) {
  return request({
    url: `${baseUrl}/data-use/role/delete`,
    method: 'post',
    data
  })
}
export function updateUserPassword (data: any) {
  return request({
    url: `${baseUrl}/data-use/user/updatePassword`,
    method: 'post',
    data
  })
}
/**
 * 管理员修改用户密码接口
 * @param data 修改密码数据
 * @param data.userId 用户ID
 * @param data.newPassword 新密码
 * @returns 修改结果
 */
export function adminUpdateUserPassword (data: {
  userId: number;
  newPassword: string;
}) {
  return request({
    url: `${baseUrl}/data-use/user/adminUpdatePassword`,
    method: 'post',
    data
  })
}

/**
 * 管理员更新用户信息接口
 * @param data 用户信息数据
 * @param data.userId 用户ID
 * @param data.username 用户名
 * @param data.email 邮箱
 * @param data.phone 电话
 * @param data.roleId 角色ID
 * @returns 更新结果
 */
export function adminUpdateUserInfo (data: {
  userId: number;
  username?: string;
  email?: string;
  phone?: string;
  roleId?: number;
}) {
  return request({
    url: `${baseUrl}/data-use/user/update`,
    method: 'post',
    data
  })
}

/**
 * 管理员删除用户接口
 * @param data 删除用户数据
 * @param data.userId 用户ID
 * @returns 删除结果
 */
export function adminDeleteUser (data: {
  userId: number;
}) {
  return request({
    url: `${baseUrl}/data-use/user/delete`,
    method: 'post',
    data
  })
}

export function getMatchScoreLive (data: {matchIds: string}) {
  return request({
    url: `${baseUrl}/data-use/match/get-match-score-live`,
    method: 'post',
    data
  })
}

export function getWcMatchScoreLive () {
  return request({
    url: `${baseUrl}/data-use/match/get-wc-match-score-live`,
    method: 'post',
  })
}
export function getWcUpdateFootballScore () {
  return request({
    url: `${baseUrl}/data-use/match/get-wc-update-football-score`,
    method: 'post',
  })
}

export function getMatchPrediction (data: any, options: { timeout?: number; silentError?: boolean } = {}) {
  return request({
    url: `${baseUrl}/data-use/get-data-by-params`,
    method: 'post',
    data,
    ...options
  })
}


export function validateToken () {
  return request({
    url: `${baseUrl}/data-use/user/validateToken`,
    method: 'get'
  })
}
export function updatePredict (data: any) {
  return request({
    url: `${baseUrl}/data-use/update-predict`,
    method: 'post',
    data
  })
}
export function uploadFile (data: any) {
  return request({
    url: `${baseUrl}/data-use/file-path/upload`,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
export function getFileList (data: any) {
  return request({
    url: `${baseUrl}/data-use/file-path/list`,
    method: 'post',
    data,
  })
}
export function deleteFileList (data: any) {
  return request({
    url: `${baseUrl}/data-use/file-path/delete`,
    method: 'post',
    data,
  })
}

export function setFileTags (ids: number[], tag: string) {
  return request({ url: `${baseUrl}/data-use/file-path/tag`, method: 'post', data: { ids, tag } })
}

export function getWxConfigList () {
  return request({
    url: `${baseUrl}/data-use/wx-config/list`,
    method: 'get',
  })
}

export function addMaterial (access_token: string, data: any) {
  return axios({
    url: `https://api.weixin.qq.com/cgi-bin/material/add_material?access_token=${access_token}&type=image`,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
export function getMatchHadOddsByMatchId (data: any) {
  return request({
    url: `${baseUrl}/data-use/match-odds/query-by-matchId`,
    method: 'post',
    data
  })
}
export function getMatchHadOddsByRangeForm (data: any) {
  return request({
    url: `${baseUrl}/data-use/match-odds/query-by-range`,
    method: 'post',
    data
  })
}

// 资产管理
export function getAssetListByUserId (data: any) {
  return request({
    url: `${baseUrl}/data-use/assets`,
    method: 'post',
    data
  })
}
export function createAsset (data: any) {
  return request({
    url: `${baseUrl}/data-use/asset`,
    method: 'post',
    data
  })
}

export function deleteAsset (data: any) {
  return request({
    url: `${baseUrl}/data-use/asset/delete`,
    method: 'post',
    data
  })
}
//创建当日资产记录
export function createDailyAsset (data: any) {
  return request({
    url: `${baseUrl}/data-use/daily-asset`,
    method: 'post',
    data
  })
}

// /data-use/daily-assets?userId=23&date=2026-05-02
export function getDailyAsset (data: any) {
  return request({
    url: `${baseUrl}/data-use/daily-assets?storeId=${data.storeId}&date=${data.date}`,
    method: 'get',
  })
}
// /daily-asset/update
export function updateDailyAsset (data: any) {
  return request({
    url: `${baseUrl}/data-use/daily-asset/update`,
    method: 'post',
    data
  })
}

///data-use/asset-log
export function createAssetLog (data: any) {
  return request({
    url: `${baseUrl}/data-use/asset-log`,
    method: 'post',
    data
  })
}

// /data-use/asset-logs?userId=23&date=2026-05-02
export function getAssetLog (data: any) {
  return request({
    url: `${baseUrl}/data-use/asset-logs?storeId=${data.storeId}&date=${data.date}`,
    method: 'get',
  })
}
// /data-use/asset-log/delete
export function deleteAssetLog (data: any) {
  return request({
    url: `${baseUrl}/data-use/asset-log/delete`,
    method: 'post',
    data
  })
}
// /data-use/asset-log/update
export function updateAssetLog (data: any) {
  return request({
    url: `${baseUrl}/data-use/asset-log/update`,
    method: 'post',
    data
  })
}


/**
 * 查询门店的资产列表
 * @param storeId 门店ID
 * @returns 资产列表
 */
export function getStoreAssets (storeId: number) {
  return request({
    url: `${baseUrl}/data-use/store-assets/${storeId}`,
    method: 'get',
  })
}

/**
 * 创建门店
 * @param data 门店数据
 * @param data.name 门店名称
 * @param data.code 门店编码（唯一）
 * @param data.address 门店地址
 * @param data.phone 联系电话
 * @param data.sort 排序
 * @returns 创建结果
 */
export function createStore (data: any) {
  return request({
    url: `${baseUrl}/data-use/store`,
    method: 'post',
    data
  })
}

/**
 * 更新门店信息
 * @param data 门店数据（包含id）
 * @param data.id 门店ID
 * @param data.name 门店名称
 * @param data.code 门店编码
 * @param data.address 门店地址
 * @param data.phone 联系电话
 * @param data.sort 排序
 * @returns 更新结果
 */
export function updateStore (data: any) {
  return request({
    url: `${baseUrl}/data-use/store/update`,
    method: 'post',
    data
  })
}

/**
 * 删除门店（逻辑删除）
 * @param data 删除数据
 * @param data.id 门店ID
 * @returns 删除结果
 */
export function deleteStore (data: any) {
  return request({
    url: `${baseUrl}/data-use/store/delete`,
    method: 'post',
    data
  })
}

/**
 * 查询门店详情
 * @param id 门店ID
 * @returns 门店详情
 */
export function getStoreById (id: number) {
  return request({
    url: `${baseUrl}/data-use/store/${id}`,
    method: 'get',
  })
}

/**
 * 查询门店列表
 * @returns 门店列表
 */
export function getStoreList () {
  return request({
    url: `${baseUrl}/data-use/stores`,
    method: 'get',
  })
}

/**
 * 用户绑定门店
 * @param data 绑定数据
 * @param data.userId 用户ID
 * @param data.storeId 门店ID
 * @returns 绑定结果
 */
export function bindStore (data: any) {
  return request({
    url: `${baseUrl}/data-use/user-store/bind`,
    method: 'post',
    data
  })
}

/**
 * 用户解绑门店
 * @param data 解绑数据
 * @param data.userId 用户ID
 * @param data.storeId 门店ID
 * @returns 解绑结果
 */
export function unbindStore (data: any) {
  return request({
    url: `${baseUrl}/data-use/user-store/unbind`,
    method: 'post',
    data
  })
}

/**
 * 查询门店关联的用户列表
 * @param storeId 门店ID
 * @returns 用户列表
 */
export function getStoreUsers (storeId: number) {
  return request({
    url: `${baseUrl}/data-use/store-users/${storeId}`,
    method: 'get',
  })
}

/**
 * 查询用户关联的门店列表
 * @param userId 用户ID
 * @returns 门店列表
 */
export function getUserStoreList (userId: number) {
  return request({
    url: `${baseUrl}/data-use/user-stores/${userId}`,
    method: 'get',
  })
}
/**
 * 获取所有联赛信息
 */
export function getOkoooLeagues() {
  return request({
    url: `${baseUrl}/data-use/okooo-leagues`,
    method: 'get',
  })
}



// ===== 文章管理 API =====
export function getArticleList(params: { page: number; pageSize: number; filter?: string }) {
  return request({
    url: `${baseUrl}/data-use/articles/list`,
    method: 'get',
    params,
  })
}

export function createArticle(data: any) {
  return request({
    url: `${baseUrl}/data-use/articles/create`,
    method: 'post',
    data,
  })
}

export function updateArticle(data: any) {
  return request({
    url: `${baseUrl}/data-use/articles/update`,
    method: 'post',
    data,
  })
}

export function deleteArticle(id: number) {
  return request({
    url: `${baseUrl}/data-use/articles/delete`,
    method: 'post',
    data: { id },
  })
}

export function cancelArticlePush(id: number) {
  return request({
    url: `${baseUrl}/data-use/articles/cancel-push`,
    method: 'post',
    data: { id },
  })
}

export function getArticleDetail(id: number) {
  return request({
    url: `${baseUrl}/data-use/articles/detail/${id}`,
    method: 'get',
  })
}

// ===== 埋点分析 API =====
export function getPvTrend(params: { start_date: string; end_date: string }) {
  return request({
    url: `${baseUrl}/data-use/analytics/pv-trend`,
    method: 'get',
    params,
  })
}

export function getUvTrend(params: { start_date: string; end_date: string }) {
  return request({
    url: `${baseUrl}/data-use/analytics/uv-trend`,
    method: 'get',
    params,
  })
}

export function getPageDistribution(params: { start_date: string; end_date: string }) {
  return request({
    url: `${baseUrl}/data-use/analytics/page-distribution`,
    method: 'get',
    params,
  })
}

export function getAiUsage(params: { start_date: string; end_date: string }) {
  return request({
    url: `${baseUrl}/data-use/analytics/ai-usage`,
    method: 'get',
    params,
  })
}

export function trackEvent(data: { events: Array<{ event_type?: string; page_path?: string; user_id?: number | null; open_id?: string | null; device_id?: string | null; timestamp?: string }> }) {
  return request({
    url: `${baseUrl}/data-use/analytics/track`,
    method: "post",
    data,
  })
}

export function optimizeArticle(data: { content: string }) {
  return request({
    url: `${baseUrl}/data-use/ai/optimize-article-stream`,
    method: "post",
    data,
  })
}


// ===== AI 比赛情报流式 API（原生 fetch，支持 SSE）=====
export function fetchMatchIntelligence(
  data: { matchId: number; matchInfo: Record<string, any> },
  callbacks: {
    onToken: (token: string) => void
    onDone: () => void
    onError: (msg: string) => void
  }
): { abort: () => void } {
  const controller = new AbortController()
  const userStore = useUserStore()
  const token = userStore.token

  const url = `${baseUrl}/data-use/ai/match-intelligence`
  fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { 'x-access-token': token } : {}),
    },
    body: JSON.stringify(data),
    signal: controller.signal,
  })
    .then(async (response) => {
      if (!response.ok) {
        if (response.status === 429) {
          try {
            const errData = await response.json()
            callbacks.onError(errData.message || '请求过于频繁')
          } catch { callbacks.onError('请求过于频繁') }
        } else {
          callbacks.onError('AI 服务异常(' + response.status + ')')
        }
        return
      }
      const result = await response.json()
      if (result.success && result.data?.content) {
        callbacks.onToken(result.data.content)
        callbacks.onDone()
      } else {
        callbacks.onError(result.message || 'AI 返回为空')
      }
    })
    .catch((err) => {
      if (err.name !== 'AbortError') {
        callbacks.onError(err.message || '网络错误')
      }
    })

  return { abort: () => controller.abort() }
}
// ===== 球队 & 球员 API =====
export function getOkoooTeams() {
  return request({
    url: `${baseUrl}/data-use/okooo-teams`,
    method: 'get',
  })
}

export function getOkoooTeamPlayers(teamId: number) {
  return request({
    url: `${baseUrl}/data-use/okooo-teams/${teamId}/players`,
    method: 'get',
  })
}

export function getOkoooTeamsWithPlayers() {
  return request({
    url: `${baseUrl}/data-use/okooo-teams/players`,
    method: 'get',
  })
}

export function getTeamFixtures() {
  return request({
    url: `${baseUrl}/data-use/okooo-teams/fixtures`,
    method: 'get',
  })
}


// ===== AI 记账 API =====

/**
 * AI 记账意图解析
 * @param text 用户输入的自然语言
 * @param storeId 门店ID
 * @param date 当前账期日期
 */
export function aiAssetAction(data: { text: string; storeId: number; date: string }) {
  return request({
    url: `${baseUrl}/data-use/ai/asset-action`,
    method: 'post',
    data,
  })
}

/**
 * AI 记账对话查询（SSE 流式）
 */
export function aiAssetChat(data: { message: string; storeId: number; date: string; history?: any[] }) {
  const token = localStorage.getItem('user')
    ? JSON.parse(localStorage.getItem('user') || '{}').token || ''
    : ''
  return fetch(`${baseUrl}/data-use/ai/asset-chat`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-access-token': token,
    },
    body: JSON.stringify(data),
  })
}

/**
 * 获取动帐类型列表（从 Dicts 读取）
 */
export function getAssetLogTypes() {
  return request({
    url: `${baseUrl}/data-use/asset-log-types`,
    method: 'get',
  })
}

export function collectorPairCode() { return request({ url: `${baseUrl}/data-use/collector/v1/admin/pair-codes`, method: 'post' }) }
export function collectorDevices() { return request({ url: `${baseUrl}/data-use/collector/v1/admin/devices`, method: 'get' }) }
export function revokeCollectorDevice(id: string) { return request({ url: `${baseUrl}/data-use/collector/v1/admin/devices/${encodeURIComponent(id)}/revoke`, method: 'post' }) }

export function collectorDeviceCommand(id: string, changes: Array<{ kind: string; command?: string; expression?: string }>, requestId: string) {
  return request({url:`${baseUrl}/data-use/collector/v1/admin/devices/${encodeURIComponent(id)}/commands`,method:'post',data:{requestId,changes}})
}
